import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import RecruitmentOverview from "./index";
import RecruitmentView from "./view";
import { FaMagnifyingGlass } from "react-icons/fa6";
import Applicants from "./applicants";

const recruitmentHrRoutes = [	
    generateCRUDRoutes({
        mainTitle: "Recruitment Overview",
        basePath: "recruitment-overview",
        mainComponent: <RecruitmentOverview />,
        layout: "/console",
        icon: <FaMagnifyingGlass className="icon-item" />,
        subTitle:"Hiring Pipeline",
        detailTitle: "",
        viewComponent: <RecruitmentView />,
        level:4,
        moduleId: 0,
    }),
    generateCRUDRoutes({
        mainTitle: "Applicants",
        basePath: "applicants",
        mainComponent: <Applicants />,
        layout: "/console",
        icon: <FaMagnifyingGlass className="icon-item" />,
        subTitle:"Hiring Pipeline",
        detailTitle: "",
        viewComponent: <Applicants />,
        level:3,
        moduleId: 0,
    }),

]

export default recruitmentHrRoutes;